import React from 'react';
import { node, string, bool } from 'prop-types';
import { any, pathEq } from 'ramda';
import Grid from '@material-ui/core/Grid';
import useStyles from './styles';
import { useConnect } from './hooks';

const Page = ({ children, name, justify = 'center', direction, fullHeight }) => {
  const { isDownsized } = useConnect();
  const classes = useStyles({ isDownsized });

  const isFooter = () => {
    return any(pathEq(['type', 'displayName'], 'Footer'), children);
  };

  return (
    <Grid
      container
      name={name}
      className={`
        ${classes.root} 
        ${isFooter() ? classes.footer : classes.page} 
        ${fullHeight ? classes.fullHeight : ''}
      `}
      justify={justify}
      direction={direction}
    >
      {children}
    </Grid>
  );
};

Page.propTypes = {
  children: node,
  name: string.isRequired,
  justify: string,
  direction: string,
  fullHeight: bool,
};

export default Page;
